// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__usY55","approved":"Status_approved__3QCqy","rejected":"Status_rejected__3NjwJ","expired":"Status_expired__2S1AC","label":"Status_label__2fI-r"};